import { render, staticRenderFns } from "./SistemasSobMedidaItajai.vue?vue&type=template&id=c207464c&scoped=true"
import script from "./SistemasSobMedidaItajai.vue?vue&type=script&lang=js"
export * from "./SistemasSobMedidaItajai.vue?vue&type=script&lang=js"
import style0 from "./SistemasSobMedidaItajai.vue?vue&type=style&index=0&id=c207464c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c207464c",
  null
  
)

export default component.exports